//
//
//
//
//
//
//
//
//

export default {
  name: 'DisparityTag',
  props: {
    disparity: {
      type: Number,
      required: true,
    },
  },
  computed: {
    disparityColor() {
      if (this.disparity < -20) {
        return 'is-danger'
      }

      if (this.disparity >= -20 && this.disparity < 0) {
        return 'is-warning'
      }

      if (this.disparity === 0) {
        return 'is-zero'
      }

      return 'is-success'
    },
    disparityIcon() {
      if (this.disparity < -20) {
        return '/img/projects/supervisor-validation/arrow-down.svg'
      }

      if (this.disparity >= -20 && this.disparity < 0) {
        return '/img/projects/supervisor-validation/yellow-arrow-down.svg'
      }

      if (this.disparity === 0) {
        return '/img/projects/supervisor-validation/equal.svg'
      }

      return '/img/projects/supervisor-validation/arrow-up.svg'
    },
  },
}
